/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core'

export default function Footer() {
    const backgroundColor = '#282C34'

    const Background = () => (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
            `}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1440 320"
            >
                <path
                    fill={backgroundColor}
                    fillOpacity="1"
                    d="M0,96L60,101.3C120,107,240,117,360,106.7C480,96,600,64,720,80C840,96,960,160,1080,176C1200,192,1320,160,1380,144L1440,128L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path>
            </svg>
        </div>
    )

    const Col1 = () => (
        <div css={css`
            display: flex;
            flex-direction: column;
        `}>
            <ul>
                <li>
                    <a href='https://onmyway133.com'>Home</a>
                </li>
                <li>
                    <a href='https://onmyway133.com/about'>About</a>
                </li>
                <li>
                    <a href='https://onmyway133.com/apps'>Apps</a>
                </li>
                <li>
                    <a href='https://onmyway133.com/opensource'>Open Source</a>
                </li>
                <li>
                    <a href='https://onmyway133.com/writing'>Blog</a>
                </li>
            </ul>
        </div>
    )

    const Col2 = () => (
        <div css={css`
            display: flex;
            flex-direction: column;
        `}>
            <ul>
                <li>
                    <a href='https://github.com/onmyway133'>GitHub</a>
                </li>
                <li>
                    <a href='https://medium.com/@onmyway133'>Medium</a>
                </li>
                <li>
                    <a href='https://twitter.com/onmyway133'>Twitter</a>
                </li>
                <li>
                    <a href='https://gumroad.com/onmyway133'>Gumroad</a>
                </li>
                <li>
                    <a href='https://producthunt.com/@onmyway133'>Product Hunt</a>
                </li>
                <li>
                    <a href='mailto:onmyway133@gmail.com'>Contact</a>
                </li>
            </ul>
        </div>
    )

    const Col3 = () => (
        <div css={css`
        `}>
            <p css={css`
                color: rgba(180, 180, 180, 1.0);

                a {
                    text-decoration: none;
                    color: pink;
                }
            `}>
                Hi there, I'm Khoa aka <a href="https://twitter.com/onmyway133">onmyway133</a>.
                I work with mobile and web technologies.
                <br />
                <br />
                Besides working full time on company projects that are used by millions of users, I also do open source and blogging.
                My <a href="https://github.com/onmyway133">GitHub</a> open source has 1.5k followers with packages that are integrated by 45k+ apps and over 3.4m+ downloads on <a href="https://cocoapods.org/owners/3739">CocoaPods</a>.
                My writing on <a href="https://medium.com/@onmyway133">Medium</a> has over 2.3k+ followers with tons of articles and 90k+ monthly views.
                <br />
                <br />
                If you like my work, please support my apps <a href="https://onmyway133.com/apps">here</a>, on <a href="https://www.producthunt.com/@onmyway133">Product Hunt</a> and <a href="https://gumroad.com/onmyway133">Gumroad</a>, thank you.
            </p>
        </div>
    )

    const MadeWith = () => (
        <div css={css`
            margin-left: 40px;
            p {
                color: rgba(180, 180, 180, 1.0);
            }
        `}>
            <p>Made with ❤️ and  ☕️ by
                <a href='https://twitter.com.onmyway133'> onmyway133</a>
            </p>
            
        </div>
    )

    const Content = () => {
        return (
            <div css={css`
                margin: 50px 8%;

                li {
                    list-style-type: none;
                    margin-bottom: 8px;
                }

                a, span {
                    text-decoration: none;
                    color: rgba(180, 180, 180, 1.0);
                    &:hover {
                        color: rgba(255, 255, 255, 1.0)
                    }
                }
            `}>
                <div css={css`

                `}>
                    <div css={css`
                        display: grid;
                    `}>
                        <div css={css`
                            display: grid;
                            grid-template-columns: 1fr 1fr 3fr;
                            grid-gap: 10px;
                            justify-content: start;
                            @media (max-width: 500px) {
                                grid-template-columns: 1fr;
                            }
                        `}>
                            <Col1 />
                            <Col2 />
                            <Col3 />
                        </div>
                        <MadeWith />
                    </div>

                </div>

            </div>
        )
    }

    return (
        <div>
            <div css={css`
                position: relative;
            `}>
                <Background />
                <div css={css`
                    position: absolute;
                    top: 60%;
                    left: 0;
                    width: 100%;
                    background-color: ${backgroundColor}
                `}>
                    <Content />
                </div>
            </div>
        </div>
    )
}